export default __webpack_public_path__ + "static/media/feature-airport.9009cb52.svg";